import { useQuery } from '@tanstack/react-query';
import httpClient from '../services/http-client';
import { OrderAuditReport } from '../types';

/**
 * Hook to fetch order audit report
 */
export function useOrderAuditReport(divisionId: string, orderId: string, enabled: boolean = true) {
  return useQuery<OrderAuditReport>({
    queryKey: ['order-audit-report', divisionId, orderId],
    queryFn: async () => {
      const response = await httpClient.get<OrderAuditReport>(
        `/api/v1.0/divisions/${divisionId}/orders/${orderId}/audit-report`
      );
      return response;
    },
    enabled: enabled && !!divisionId && !!orderId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
